// @ts-nocheck
// @ts-ignore
// Docs: https://github.com/RonaldJerez/vue-input-facade
import Vue from 'vue'
import InputFacade from 'vue-input-facade'
Vue.use(InputFacade)

export default InputFacade
